import * as t from 'io-ts';
import { nonEmptyString } from '../utils';

const Transcoding = t.exact(t.interface({
  host: nonEmptyString,
  protocol: t.union([t.literal('http:'), t.literal('https:')]),
  shards: t.number,
  startIndex: t.union([t.literal(0), t.literal(1)]),
}), 'Transcoding');

export type ITranscoding = t.TypeOf<typeof Transcoding>;

export default Transcoding;
